import { Box, Button } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";

const useStyles = makeStyles(theme => ({
    buttons: {
        flexGrow: 1,
        padding: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column'
    },
}));

interface Props
{
    id: string
    goto?: { label: string, destination: string }[]
    onClickGoto: (id: string) => void
}

export default function Goto({id, goto, onClickGoto }: Props)
{
    const classes = useStyles();

    const handleClickGoto = (event: React.MouseEvent<HTMLElement>) =>
    {
        onClickGoto(event.currentTarget.dataset.destination || "");
        event.preventDefault();
    }
    
    return <Box className={classes.buttons}>
        {(goto || []).map((transition: { label: string, destination: string }, index: number) =>
            <Button key={`${id}_${transition.destination}_${index}`} variant="contained" data-destination={transition.destination}
                onClick={handleClickGoto} size="small">
                {transition.label}
            </Button>)}
    </Box>
}